import { render } from "./calendar_reservation.vue?vue&type=template&id=80685c2a"
import script from "./calendar_reservation.vue?vue&type=script&lang=js"
export * from "./calendar_reservation.vue?vue&type=script&lang=js"

import "./calendar_reservation.vue?vue&type=style&index=0&id=80685c2a&lang=css"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\Developpement\\_VELO\\demo-location.accen.me\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__